import React, { useState } from 'react'
import Style from './createConnector.module.css'
import SystemTile from './SystemTile'
import SearchBar from '../../SharedComponents/SearchBar/SearchBar'
import CategoryFilter from '../../SharedComponents/CategoryFilter/CategoryFilter'
import { CATEGORIES, matchesSearch } from '../../../features/marketplace/connectorCatalog'

const ALL = 'all'

const ChooseSystemStep = ({ systems, isLoading, isError, onRetry, selectedId, onSelect }) => {
    const [search, setSearch] = useState('')
    const [category, setCategory] = useState(ALL)

    if (isLoading) {
        return (
            <div className={Style.tiles} aria-busy="true">
                {Array.from({ length: 8 }).map((_, index) => <span key={index} className={Style.skeleton} />)}
            </div>
        )
    }
    if (isError) {
        return (
            <p className={Style.message} role="alert">
                The systems could not be loaded. <button type="button" className={Style.textButton} onClick={onRetry}>Try again</button>
            </p>
        )
    }

    const searched = systems.filter((system) => matchesSearch(system, search))
    const visible = category === ALL ? searched : searched.filter((system) => system.category === category)
    const options = [
        { key: ALL, label: 'All', count: searched.length },
        ...CATEGORIES
            .map((info) => ({ key: info.key, label: info.label, count: searched.filter((system) => system.category === info.key).length }))
            .filter((option) => option.count > 0 || option.key === category)
    ]

    return (
        <>
            <div className={Style.toolbar}>
                <SearchBar className={Style.search} value={search} onChange={setSearch} placeholder="Search systems" label="Search systems" />
                <CategoryFilter options={options} value={category} onChange={setCategory} label="System categories" />
            </div>
            {visible.length === 0 ? (
                <p className={Style.message}>
                    No systems match your search.{' '}
                    <button type="button" className={Style.textButton} onClick={() => { setSearch(''); setCategory(ALL) }}>Clear filters</button>
                </p>
            ) : (
                <div className={Style.tiles}>
                    {visible.map((system) => (
                        <SystemTile key={system.id} system={system} isSelected={String(system.id) === String(selectedId)} onSelect={onSelect} />
                    ))}
                </div>
            )}
        </>
    )
}

export default ChooseSystemStep
